var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.templateClasses()},[_c('div',{class:_vm.iconClasses(_vm.expansion)}),_vm._v(" "),_vm._l((_vm.modules()),function(module){return _c('div',{key:module,class:_vm.iconClasses(module)})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }